import { useCallback, useState } from 'react';
import { getText } from 'i18n/intl';
import { TType } from '@timeedit/types';
import { Button, Tooltip } from '@timeedit/ui-components';
import { JobObjectSelection } from '../hooks/useJobSubmit';
import ObjectManagerExportModal from './export/ObjectManagerExportModal';

const EXPORT_LIMIT = 200_000;

type Props = {
  selectedObjectsCount: number;
  disabled: boolean;
  jobObjectSelection: JobObjectSelection;
  objectType: TType | null;
};

const ExportObjectsJobButton: React.FC<Props> = ({
  disabled,
  selectedObjectsCount,
  jobObjectSelection,
  objectType,
}: Props) => {
  const [isExportOpen, setIsExportOpen] = useState(false);

  const handleExportModalOpen = useCallback(() => {
    setIsExportOpen(true);
  }, []);

  const handleExportModalClose = useCallback(() => {
    setIsExportOpen(false);
  }, []);

  const reachedExportLimit = selectedObjectsCount > EXPORT_LIMIT;

  return (
    <>
      <Tooltip
        title={
          reachedExportLimit ? `Limit of ${EXPORT_LIMIT} exceeded` : undefined
        }
      >
        <Button
          disabled={disabled || reachedExportLimit}
          key="export-button"
          size="small"
          onClick={handleExportModalOpen}
        >
          {getText('object_manager.export-modal.ok-text')}{' '}
        </Button>
      </Tooltip>

      {isExportOpen && (
        <ObjectManagerExportModal
          open={isExportOpen}
          onClose={handleExportModalClose}
          selectedObjectsCount={selectedObjectsCount}
          objectType={objectType}
          jobObjectSelection={jobObjectSelection}
        />
      )}
    </>
  );
};

export default ExportObjectsJobButton;
